import useODSPlugin from "@/useODSPlugin.ts";
import {createApp} from 'vue'
import App from './App.vue'
import { router } from './router'
import { i18n } from './i18n'
import Toast from "vue-toastification";
import { RouterLink } from 'vue-router';

import ODSComponents from 'omind-design-system/components/'

import "vue-toastification/dist/index.css";

import 'omind-design-system/assets/styles/all.scss'
import './assets/styles/style.css'
import './assets/styles/ods-style.scss'
import { isInLocalDevelopmentMode } from '@/functions/development';
import axios from 'axios';
import { initAnalytics } from "@/domains/-analytics";

if(isInLocalDevelopmentMode()){
  axios.defaults.headers.common['Origin'] = 'https://sta-hub.omind.me'
}

const toastOptions = {
  position: "top-right",
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: "button",
  icon: true,
  rtl: false,
  transition: "Vue-Toastification__fade",
  maxToasts: 20,
  newestOnTop: true
}

const app = createApp(App)

if (import.meta.env.VITE_ICONS_URL) {
  app.provide('odsIconPath', import.meta.env.VITE_ICONS_URL)
}
app.provide('RouterLinkComponent', RouterLink)

app.use(router)
app.use(i18n)
app.use(Toast, toastOptions)
//@ts-ignore
app.use(ODSComponents)
app.use(useODSPlugin);

app.mount('#app');


initAnalytics()
